"use strict";
// tslint:disable
/**
 * Microtica Elasticsearch Microservice
 * API for Elasticsearch Microservice
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsElasticsearchApi = exports.MsElasticsearchApiFactory = exports.MsElasticsearchApiFp = exports.MsElasticsearchApiAxiosParamCreator = exports.StageDeploymentResponseComponentCloudProviderEnum = exports.StageDeploymentResponseComponentInfrastructureAsCodeToolEnum = exports.StageDeploymentResponseComponentTypeEnum = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var StageDeploymentResponseComponentTypeEnum;
(function (StageDeploymentResponseComponentTypeEnum) {
    StageDeploymentResponseComponentTypeEnum["Kubernetes"] = "kubernetes";
    StageDeploymentResponseComponentTypeEnum["Database"] = "database";
    StageDeploymentResponseComponentTypeEnum["Storage"] = "storage";
    StageDeploymentResponseComponentTypeEnum["VirtualMachine"] = "virtual-machine";
    StageDeploymentResponseComponentTypeEnum["Lambda"] = "lambda";
    StageDeploymentResponseComponentTypeEnum["Vpc"] = "vpc";
    StageDeploymentResponseComponentTypeEnum["Other"] = "other";
})(StageDeploymentResponseComponentTypeEnum = exports.StageDeploymentResponseComponentTypeEnum || (exports.StageDeploymentResponseComponentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var StageDeploymentResponseComponentInfrastructureAsCodeToolEnum;
(function (StageDeploymentResponseComponentInfrastructureAsCodeToolEnum) {
    StageDeploymentResponseComponentInfrastructureAsCodeToolEnum["Terraform"] = "terraform";
    StageDeploymentResponseComponentInfrastructureAsCodeToolEnum["Cloudformation"] = "cloudformation";
})(StageDeploymentResponseComponentInfrastructureAsCodeToolEnum = exports.StageDeploymentResponseComponentInfrastructureAsCodeToolEnum || (exports.StageDeploymentResponseComponentInfrastructureAsCodeToolEnum = {}));
/**
    * @export
    * @enum {string}
    */
var StageDeploymentResponseComponentCloudProviderEnum;
(function (StageDeploymentResponseComponentCloudProviderEnum) {
    StageDeploymentResponseComponentCloudProviderEnum["Aws"] = "aws";
    StageDeploymentResponseComponentCloudProviderEnum["Azurerm"] = "azurerm";
    StageDeploymentResponseComponentCloudProviderEnum["Google"] = "google";
})(StageDeploymentResponseComponentCloudProviderEnum = exports.StageDeploymentResponseComponentCloudProviderEnum || (exports.StageDeploymentResponseComponentCloudProviderEnum = {}));
/**
 * MsElasticsearchApi - axios parameter creator
 * @export
 */
var MsElasticsearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get deployed microservice
         * @param {string} projectId
         * @param {string} kubernetesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeployedMicroservices: function (projectId, kubernetesId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getDeployedMicroservices.');
            }
            // verify required parameter 'kubernetesId' is not null or undefined
            if (kubernetesId === null || kubernetesId === undefined) {
                throw new base_1.RequiredError('kubernetesId', 'Required parameter kubernetesId was null or undefined when calling getDeployedMicroservices.');
            }
            var localVarPath = "/search/deployed-microservices";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (kubernetesId !== undefined) {
                localVarQueryParameter['kubernetesId'] = kubernetesId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get terraform deployment time
         * @param {string} projectId
         * @param {string} [stageId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentTime: function (projectId, stageId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getDeploymentTime.');
            }
            var localVarPath = "/search/deployment-time";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (stageId !== undefined) {
                localVarQueryParameter['stageId'] = stageId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Pipeline Metrics
         * @param {string} projectId
         * @param {string} [pipelineId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineMetrics: function (projectId, pipelineId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getPipelineMetrics.');
            }
            var localVarPath = "/search/pipeline-metrics";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (pipelineId !== undefined) {
                localVarQueryParameter['pipelineId'] = pipelineId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Service Deployment History
         * @param {string} projectId
         * @param {string} [microserviceName]
         * @param {string} [kubernetesId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceDeploymentHistory: function (projectId, microserviceName, kubernetesId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getServiceDeploymentHistory.');
            }
            var localVarPath = "/search/service-deployment-history";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (microserviceName !== undefined) {
                localVarQueryParameter['microserviceName'] = microserviceName;
            }
            if (kubernetesId !== undefined) {
                localVarQueryParameter['kubernetesId'] = kubernetesId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stage Deployment History
         * @param {string} projectId
         * @param {string} stageId
         * @param {string} [deploymentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageDeploymentHistory: function (projectId, stageId, deploymentId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'projectId' is not null or undefined
            if (projectId === null || projectId === undefined) {
                throw new base_1.RequiredError('projectId', 'Required parameter projectId was null or undefined when calling getStageDeploymentHistory.');
            }
            // verify required parameter 'stageId' is not null or undefined
            if (stageId === null || stageId === undefined) {
                throw new base_1.RequiredError('stageId', 'Required parameter stageId was null or undefined when calling getStageDeploymentHistory.');
            }
            var localVarPath = "/search/stage-deployment-history";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (stageId !== undefined) {
                localVarQueryParameter['stageId'] = stageId;
            }
            if (deploymentId !== undefined) {
                localVarQueryParameter['deploymentId'] = deploymentId;
            }
            if (projectId !== undefined && projectId !== null) {
                localVarHeaderParameter['projectId'] = String(projectId);
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MsElasticsearchApiAxiosParamCreator = MsElasticsearchApiAxiosParamCreator;
/**
 * MsElasticsearchApi - functional programming interface
 * @export
 */
var MsElasticsearchApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get deployed microservice
         * @param {string} projectId
         * @param {string} kubernetesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeployedMicroservices: function (projectId, kubernetesId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getDeployedMicroservices(projectId, kubernetesId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get terraform deployment time
         * @param {string} projectId
         * @param {string} [stageId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentTime: function (projectId, stageId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getDeploymentTime(projectId, stageId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Search Pipeline Metrics
         * @param {string} projectId
         * @param {string} [pipelineId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineMetrics: function (projectId, pipelineId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getPipelineMetrics(projectId, pipelineId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Service Deployment History
         * @param {string} projectId
         * @param {string} [microserviceName]
         * @param {string} [kubernetesId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceDeploymentHistory: function (projectId, microserviceName, kubernetesId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getServiceDeploymentHistory(projectId, microserviceName, kubernetesId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Stage Deployment History
         * @param {string} projectId
         * @param {string} stageId
         * @param {string} [deploymentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageDeploymentHistory: function (projectId, stageId, deploymentId, options) {
            var localVarAxiosArgs = (0, exports.MsElasticsearchApiAxiosParamCreator)(configuration).getStageDeploymentHistory(projectId, stageId, deploymentId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.MsElasticsearchApiFp = MsElasticsearchApiFp;
/**
 * MsElasticsearchApi - factory interface
 * @export
 */
var MsElasticsearchApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get deployed microservice
         * @param {string} projectId
         * @param {string} kubernetesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeployedMicroservices: function (projectId, kubernetesId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getDeployedMicroservices(projectId, kubernetesId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get terraform deployment time
         * @param {string} projectId
         * @param {string} [stageId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentTime: function (projectId, stageId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getDeploymentTime(projectId, stageId, options)(axios, basePath);
        },
        /**
         *
         * @summary Search Pipeline Metrics
         * @param {string} projectId
         * @param {string} [pipelineId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineMetrics: function (projectId, pipelineId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getPipelineMetrics(projectId, pipelineId, options)(axios, basePath);
        },
        /**
         *
         * @summary Service Deployment History
         * @param {string} projectId
         * @param {string} [microserviceName]
         * @param {string} [kubernetesId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceDeploymentHistory: function (projectId, microserviceName, kubernetesId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getServiceDeploymentHistory(projectId, microserviceName, kubernetesId, options)(axios, basePath);
        },
        /**
         *
         * @summary Stage Deployment History
         * @param {string} projectId
         * @param {string} stageId
         * @param {string} [deploymentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageDeploymentHistory: function (projectId, stageId, deploymentId, options) {
            return (0, exports.MsElasticsearchApiFp)(configuration).getStageDeploymentHistory(projectId, stageId, deploymentId, options)(axios, basePath);
        },
    };
};
exports.MsElasticsearchApiFactory = MsElasticsearchApiFactory;
/**
 * MsElasticsearchApi - object-oriented interface
 * @export
 * @class MsElasticsearchApi
 * @extends {BaseAPI}
 */
var MsElasticsearchApi = /** @class */ (function (_super) {
    __extends(MsElasticsearchApi, _super);
    function MsElasticsearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get deployed microservice
     * @param {string} projectId
     * @param {string} kubernetesId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getDeployedMicroservices = function (projectId, kubernetesId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getDeployedMicroservices(projectId, kubernetesId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get terraform deployment time
     * @param {string} projectId
     * @param {string} [stageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getDeploymentTime = function (projectId, stageId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getDeploymentTime(projectId, stageId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Search Pipeline Metrics
     * @param {string} projectId
     * @param {string} [pipelineId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getPipelineMetrics = function (projectId, pipelineId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getPipelineMetrics(projectId, pipelineId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Service Deployment History
     * @param {string} projectId
     * @param {string} [microserviceName]
     * @param {string} [kubernetesId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getServiceDeploymentHistory = function (projectId, microserviceName, kubernetesId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getServiceDeploymentHistory(projectId, microserviceName, kubernetesId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Stage Deployment History
     * @param {string} projectId
     * @param {string} stageId
     * @param {string} [deploymentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MsElasticsearchApi
     */
    MsElasticsearchApi.prototype.getStageDeploymentHistory = function (projectId, stageId, deploymentId, options) {
        return (0, exports.MsElasticsearchApiFp)(this.configuration).getStageDeploymentHistory(projectId, stageId, deploymentId, options)(this.axios, this.basePath);
    };
    return MsElasticsearchApi;
}(base_1.BaseAPI));
exports.MsElasticsearchApi = MsElasticsearchApi;
//# sourceMappingURL=api.js.map